import { FilterPlusOutlineIcon } from './FilterPlusOutlineIcon';

/**
 * author: GreenTurtwig
 * id 69D6704C-5371-48C4-AAE1-A53EB581CF72
 * name filter-plus-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filter-plus-outline.svg
 * tags
 */
export const FunnelPlusOutlineIcon = FilterPlusOutlineIcon;
export default FunnelPlusOutlineIcon